import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import CategoryPage from './pages/CategoryPage/CategoryPage';
import Solutions from './pages/Solutions/Solutions';
import ClevrStudio from './pages/ClevrStudio/ClevrStudio';
import Projects from './pages/Projects/Projects';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/clevr-studio" element={<ClevrStudio />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/product/:productId" element={<ProductDetail />} />
        </Routes>
        <WhatsAppButton />
      </div>
    </Router>
  );
};

export default App;
